import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { ToastContainer } from 'react-toastify';
import React, { useEffect } from 'react';
import { useAuth0 } from "./react-auth0-spa";
import { loginWithRedirectParams } from "./utils/authToken";
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';

const loadingSpinner = () => <div className="animated fadeIn pt-3 text-center"><div className="sk-spinner sk-spinner-pulse"></div></div>;

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

const App = () => {
  const { isAuthenticated, loginWithRedirect, user, loading } = useAuth0();

  useEffect(() => {
    document.title = process.env.REACT_APP_TITLE;
  }, []);

  useEffect(() => {
    if (!loading && isAuthenticated === false) {
      loginWithRedirect(loginWithRedirectParams);
    }
  }, [loading, isAuthenticated, loginWithRedirect]);

  if (loading || isAuthenticated === false) {
    return loadingSpinner();
  }

  if (!user) {
    return null;
  }

  return (
    <HashRouter>
      <React.Suspense fallback={loadingSpinner()}>
        <Switch>
          <Route path="/" name="Home" render={props => <TheLayout {...props} />} />
        </Switch>
      </React.Suspense>
      <ToastContainer />
    </HashRouter>
  );
}
export default App;
